import React from 'react';
import { RouteComponentProps } from 'react-router';
import { ProfileUpdateContainer } from '../../epic/profile-update';

export const Page: React.FC<RouteComponentProps> = () => {
  return <ProfileUpdateContainer />;
};
